import { jsx as u } from "react/jsx-runtime";
import d, { useEffect as l, useContext as o } from "react";
const f = ({
  themeName: t,
  overrides: e
} = {}) => {
  l(() => {
    t && document.documentElement.setAttribute("data-theme", t), e && Object.entries(e).forEach(([c, r]) => {
      document.documentElement.style.setProperty(c, r);
    });
  }, [t, e]);
}, m = d.createContext(
  {}
), L = () => o(m), h = ({
  client: t,
  options: e,
  children: c
}) => {
  var r, a;
  return f({
    themeName: (r = e == null ? void 0 : e.appearance) == null ? void 0 : r.theme,
    overrides: (a = e == null ? void 0 : e.appearance) == null ? void 0 : a.variables
  }), /* @__PURE__ */ u(
    m.Provider,
    {
      value: {
        client: t,
        options: e
      },
      children: c
    }
  );
};
export {
  m as LocalLogicContext,
  h as LocalLogicProvider,
  L as useLocalLogic
};
